import React, { Suspense } from 'react';
import { HeadingSkeleton } from './Heading';
import { Subcollections } from './Subcollections';
import { hierarchyFacetKey, supplementaryData, templateSuffix } from '../../configs';
import { FeaturedCollectionSkeleton } from './FeaturedCollections';
import { Breadcrumbs } from './Breadcrumbs';
import { ArtistBannerSkeleton } from './ArtistBanner';
import { FeaturedProductsSkeleton } from './FeaturedProducts';
const Heading = React.lazy(async () => await import('./Heading/Heading').then(({ Heading }) => ({ default: Heading })));
const FeaturedCollections = React.lazy(async () => await import('./FeaturedCollections/FeaturedCollections').then(({ FeaturedCollections }) => ({ default: FeaturedCollections })));
const FeaturedProducts = React.lazy(async () => await import('./FeaturedProducts/FeaturedProducts').then(({ FeaturedProducts }) => ({ default: FeaturedProducts })));
const InternalLinks = React.lazy(async () => await import('./InternalLinks/InternalLinks').then(({ InternalLinks }) => ({ default: InternalLinks })));
const ArtistBanner = React.lazy(async () => await import('./ArtistBanner/ArtistBanner').then(({ ArtistBanner }) => ({ default: ArtistBanner })));
export const Header = () => {
    if (templateSuffix === 'artist') {
        return (React.createElement(Suspense, { fallback: React.createElement(ArtistBannerSkeleton, null) },
            React.createElement(ArtistBanner, null)));
    }
    return (React.createElement("div", null,
        React.createElement(Breadcrumbs, null),
        React.createElement(Suspense, { fallback: React.createElement(HeadingSkeleton, null) },
            React.createElement(Heading, null)),
        (templateSuffix === 'shapes' ||
            templateSuffix === 'pieces' ||
            templateSuffix === 'mediums') &&
            React.createElement(Suspense, null,
                React.createElement(InternalLinks, null)),
        supplementaryData.featuredCollections !== undefined &&
            React.createElement(Suspense, { fallback: React.createElement(FeaturedCollectionSkeleton, null) },
                React.createElement(FeaturedCollections, null)),
        supplementaryData.featuredProducts !== undefined &&
            React.createElement(Suspense, { fallback: React.createElement(FeaturedProductsSkeleton, null) },
                React.createElement(FeaturedProducts, null)),
        hierarchyFacetKey.length > 0 &&
            React.createElement(Subcollections, null)));
};
